module.exports = __webpack_public_path__ + "static/media/library.349a1441.png";